var map = {
	"./iOS_2025_de.pdf": 6365,
	"./iOS_2025_en.pdf": 8758,
	"./iOS_2025_es.pdf": 8663,
	"./iOS_2025_fr.pdf": 9934,
	"./iOS_2025_ms.pdf": 9400,
	"./iOS_2025_pl.pdf": 2833
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5664;